<template>
  <div
    v-tippy="{
      theme: `${DROP_LIST_THEMES.COMMON_TOOLTIP_THEMES} ${DROP_LIST_THEMES.TEXT_CENTER}`,
      content: item.tooltipContent,
      placement: 'top'
    }"
    :style="{
      '--align': item.align
    }"
    @click="onClick"
  >
    <AppIcon
      v-if="item.icon && isString(item.icon)"
      :icon-name="item.icon"
      class="dmi-Icon"
      height="24"
      width="24"
    />

    <OkrIcon v-if="shouldShowOkrIcon" :objective="levelToOkrIconElement(item)" />

    <slot :item="item" name="item-label">
      <template v-if="item.title">
        {{ $t(item.title) }}
      </template>

      <template v-if="item.label">
        {{ item.label }}
      </template>
    </slot>

    <slot />
  </div>
</template>

<script setup>
import { isObject, isString } from 'lodash'
import { computed } from 'vue'

import { DROP_LIST_THEMES } from '@/utils/components-configurations/app-droplist'
import { levelToOkrIconElement } from '@/utils/objectives'

import OkrIcon from '@/components/objectives/items/OkrIcon'
import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'DropdownMenuItem'
})

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const emit = defineEmits({
  click: null
})

const onClick = () => {
  emit('click')
}

const shouldShowOkrIcon = computed(() => {
  const { item } = props
  const isBaseOkrElement = !item.icon && item.prefix && item.color
  const isWorkItemElement = item.icon && isObject(item.icon) && !item.prefix && item.color

  return isBaseOkrElement || isWorkItemElement
})
</script>

<style lang="scss" scoped>
.dmi-Icon {
  color: var(--icon-color, inherit);
}
</style>
